import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "common/configs/axiosConfigs";
import { toast } from "react-toastify";
import CreateContact from "./CreateContact";

const EditContact = () => {
  const { id } = useParams();
  const companyId = JSON.parse(localStorage.getItem("user-auth")).company_id;
  const [contact, setContact] = useState({});
  const getContact = async () => {
    try {
      const { data } = await axios.post("", {
        action: "getSingleContact",
        contactId: id,
        companyId,
      });
      if (data?.success) {
        setContact(data?.data);
      } else {
        toast.error(data?.error);
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    getContact();
  }, []);

  return <CreateContact {...{ contact }} />;
};

export default EditContact;
